import React from 'react';
import styled from 'styled-components';
import logo from '../img/minhalogo.svg';

function Header() {
  const HEADER = styled.header`
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 1.25rem 0;
    background-color: transparent;
    position: fixed;
    z-index: 9999999;
    @media (max-width: 1000px) {
      background: rgba(8, 8, 8, 0.2);
      backdrop-filter: blur(5px);
      -webkit-backdrop-filter: blur(5px);
    }
  `;

  const Img = styled.img`
    padding: 0 1.5rem;
    background-color: transparent;
  `;

  return (
    <HEADER>
      <Img src={logo} alt="logo murilo cardoso dos santos" />
    </HEADER>
  );
}

export default Header;
